import { CommonModule, JsonPipe } from '@angular/common';
import { Component, EventEmitter, forwardRef, inject, Input, Optional, Output, Self } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, NG_VALUE_ACCESSOR, NgControl, ReactiveFormsModule } from '@angular/forms';
import { NgbAlertModule, NgbCalendar, NgbDate, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-custom-date-range-picker',
  standalone: true,
  imports: [NgbDatepickerModule, NgbAlertModule, ReactiveFormsModule, FormsModule],
  templateUrl: './custom-date-range-picker.component.html',
  styleUrl: './custom-date-range-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDateRangePickerComponent),
      multi: true
    }
  ]
})
export class CustomDateRangePickerComponent implements ControlValueAccessor {
  calendar = inject(NgbCalendar)

  model!: NgbDateStruct;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate = this.calendar.getToday();
  toDate: NgbDate | null = this.calendar.getNext(this.fromDate, 'd', 10);

  @Input() id: string = '';
  @Input() isDateRange: boolean = false;
  @Input() hideClearButton: boolean = false;
  @Input() placeholder: string = "Date";
  @Input() disableUntilDate: Date | null = null;
  @Input() formControlName: string = '';
  @Input() formControl!: FormControl;

  @Output()
  change = new EventEmitter<NgbDateStruct>();


  myForm: FormGroup;


  constructor(private fb: FormBuilder) {
    this.myForm = this.fb.group({
      myDate: this.fb.control(null)
    })
  }


  onTouched: () => void = () => { };
  onChange: (value: any) => void = () => { };

  writeValue(value: Date | string | NgbDate | object): void {
    if (value) {
      if (typeof value === 'string') {
        value = new Date(value);
      }
      if (value instanceof NgbDate) {
        value = new Date(value.year, value.month - 1, value.day);
      }
      if (typeof value === 'object'
        && !(value instanceof Date)
        && value.hasOwnProperty('year')
        && value.hasOwnProperty('month')
        && value.hasOwnProperty('day')) {
        const temp = value as any;
        value = new Date(temp['year'], temp['month'] - 1, temp['day']);
      }

      if (value instanceof Date) {
        this.myForm.patchValue({ myDate: value });
        this.myForm.updateValueAndValidity();
        const ngbDate: NgbDateStruct = {
          day: value.getDate(), month: value.getMonth() + 1, year: value.getFullYear()
        };
        this.model = ngbDate;
      } else {
        throw new Error('Written date was not parseable');
      }
    }

    this.change.emit(this.myForm.get('myDate')?.value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.myForm.disable();
    } else {
      this.myForm.enable();
    }
  }

  onDateSelection(date: NgbDate) {
    this.formControl.patchValue(date);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  onChangeSubcription: Subscription | undefined = undefined;

  ngOnDestroy(): void {
    if (this.onChangeSubcription) {
      this.onChangeSubcription.unsubscribe();
    }
  }
}
